import { Navigate, Outlet } from "react-router-dom";
import AppelPage from "../pages/appel/AppelPage";
import AppelCreatePage from "../pages/appel/ui/AppelCreatePage";
import BulletinPage from "../pages/bulletin/BulletinPage";
import BulletinEleve from "../pages/bulletin/ui/BulletinEleve";
import BulletinListByClasse from "../pages/bulletin/ui/BulletinListByClasse";
import BulletinNote from "../pages/bulletin/ui/BulletinNote";
import CoachPage from "../pages/coach/CoachPage";
import CaochDetailsPage from "../pages/coach/ui/CaochDetailsPage.jsx";
import CoachAppelDetails from "../pages/coach/ui/CoachAppelDetailsPage.jsx";
import CoachSuiviPage from "../pages/coach/ui/CoachSuiviPage.jsx";
import CompositionPage from "../pages/composition/CompositionPage";
import CompositionLIstePage from "../pages/composition/ui/CompositionLIstePage";
import DashboardPage from "../pages/dasboard/DashboardPage";
import DiagnostiqueListe from "../pages/diagnostiques/DiagnostiqueListe";
import DiagnostiqueListeDetails from "../pages/diagnostiques/DiagnostiqueListeDetails";
import DiagnostiquePage from "../pages/diagnostiques/DiagnostiquePage";
import EpreuveByNiveauPage from "../pages/diagnostiques/epreuves/EpreuveByNiveau";
import EpreuveCoachPage from "../pages/diagnostiques/epreuves/EpreuveCoachPage.jsx";
import EpreuveDetailPage from "../pages/diagnostiques/epreuves/EpreuveDetails";
import EpreuvePage from "../pages/diagnostiques/epreuves/EpreuvePage";
import ParentDiagnosticPage from "../pages/diagnostiques/parent/ParentDiagnosticPage";
import DiagnosticParentEleve from "../pages/diagnostiques/parents/DiagnosticParentEleve.jsx";
import DiagnosticParentPage from "../pages/diagnostiques/parents/DiagnosticParentPage";
import DiagnostiqueParentListe from "../pages/diagnostiques/parents/DiagnostiqueParentList";
import DiagnostiqueQuizzDetails from "../pages/diagnostiques/parents/quizz/DiagnostiqueQuizzDetails";
import DiagnostiqueQuizzForm from "../pages/diagnostiques/parents/quizz/DiagnostiqueQuizzForm";
import DiagnostiqueQuizzList from "../pages/diagnostiques/parents/quizz/DiagnostiqueQuizzList";
import FeatureUsageStats from "../pages/diagnostiques/FeatureUsageStats";
import EcolePage from "../pages/ecole/EcolePage";
import EcoleDirecteurPage from "../pages/ecole/ui/EcoleDirecteurPage";
import EcoleListePage from "../pages/ecole/ui/EcoleListePage";
import EcoleMaitrePage from "../pages/ecole/ui/EcoleMaitrePage";
import ParrainPage from "../pages/ecole/ui/ParrainPage";
import ClassePage from "../pages/ecole/ui/classe/ClassePage";
import MatierePage from "../pages/ecole/ui/matiere/MatierePage";
import NiveauxPage from "../pages/ecole/ui/niveaux/NiveauxPage";
import ElevePage from "../pages/eleve/ElevePage";
import EleveDetailsPage from "../pages/eleve/ui/EleveDetailsPage";
import EleveDiagnostiqueNotePage from "../pages/eleve/ui/EleveDiagnostiqueNotePage.jsx";
import EleveActivitesPage from "../pages/eleve/ui/EleveActivitesPage.jsx";
import EleveActiviteDetailPage from "../pages/eleve/ui/EleveActiviteDetailPage.jsx";
import CohortesPage from "../pages/cohortes/CohortesPage.jsx";
import FicheAjoutPage from "../pages/fiches/FicheAjoutPage";
import FichePage from "../pages/fiches/FichePage";
import FicheDetailsPage from "../pages/fiches/components/FicheEdit";
import ListeCoachsFiche from "../pages/fiches/ui/ListeCoachsFiche.jsx";
import LoginPage from "../pages/login/LoginPage";
import PaiementElevePage from "../pages/paiement/PaiementElevePage.js";
import PaiementPage from "../pages/paiement/PaiementPage";
import PaiementParentPage from "../pages/paiement/PaiementParentPage.js";
import ParentPage from "../pages/parent/ParentPage";
import ParraintPage from "../pages/parraint/ParraintPage.jsx";
import PartenaireHomePage from "../pages/partenaires/pages/home/PartenaireHomePage.jsx";
import PartenaireParentPage from "../pages/partenaires/pages/parent/PartenaireParentPage.jsx";
import ContactPage from "../pages/prospects/ContactPage.jsx";
import ProspectsIndexPage from "../pages/prospects/ProspectIndexPage.jsx";
import ProspectPage from "../pages/prospects/ProspectPage.jsx";
import PhoneAnalyzer from "../pages/statistiques/PhoneAnalyzer";
import StatistiquesPage from "../pages/statistiques/StatistiquesPage";
import VillePage from "../pages/ville/VillePage.jsx";
import {
  ACCEUIL,
  APPELS_PATH,
  BULLETIN_PATH,
  CLASSES_PATH,
  COACHS_PATH,
  COMPOSITION_PATH,
  DIAGNOSTIQUES_PARENT_FOR_STUDENTS_PATH,
  DIAGNOSTIQUES_PARENT_PATH,
  DIAGNOSTIQUES_PATH,
  ECOLES_PATH,
  ELEVES_PATH,
  COHORTES_PATH,
  FICHES_PATH,
  LOGIN,
  MATIERES_PATH,
  NIVEAUX_PATH,
  PAIEMENTS_PATH,
  PARENTS_PATH,
  PARTENAIRE_PATH,
  PROSPECTS_PATH,
  STATISTIQUES_PATH,
  VILLES_PATH,
} from "../utils/navigationPaths";

export const publicRoutes = [
  {
    path: "*",
    element: <Navigate to={LOGIN} />,
  },
  {
    path: "/",
    element: <Navigate to={LOGIN} />,
  },
  {
    path: LOGIN,
    element: <LoginPage />,
  },
];

export const privateRoutes = [
  {
    path: "/admin",
    element: <Navigate to={ACCEUIL} />,
  },
  {
    path: ACCEUIL,
    element: <DashboardPage />,
  },
  {
    path: STATISTIQUES_PATH,
    element: <StatistiquesPage />,
  },
  {
    path: COHORTES_PATH,
    element: <CohortesPage />,
  },
  {
    path: "analyseur-numeros",
    element: <PhoneAnalyzer />,
  },
  {
    path: ELEVES_PATH,
    element: <Outlet />,
    subPath: [
      {
        path: "",
        element: <ElevePage />,
      },
      {
        path: ":id",
        element: <Outlet />,
        subPath: [
          {
            path: "",
            element: <EleveDetailsPage />,
          },
          {
            path: "notes",
            element: <EleveDiagnostiqueNotePage />,
          },
          {
            path: "activites",
            element: <Outlet />,
            subPath: [
              {
                path: "",
                element: <EleveActivitesPage />,
              },
              {
                path: ":type/:activityId",
                element: <EleveActiviteDetailPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: COACHS_PATH,
    element: <Outlet />,
    subPath: [
      {
        path: "",
        element: <CoachPage />,
      },
      {
        path: "suivi",
        element: <CoachSuiviPage />,
      },
      {
        path: ":id",
        element: <Outlet />,
        subPath: [
          {
            path: "",
            element: <CaochDetailsPage />,
          },
          {
            path: "appels",
            element: <CoachAppelDetails />,
          },
        ],
      },
    ],
  },
  {
    path: PARENTS_PATH,
    element: <ParentPage />,
  },
  {
    path: "partenaires",
    element: <ParraintPage />,
  },
  {
    path: PROSPECTS_PATH,
    element: <ProspectsIndexPage />,
    subPath: [
      {
        path: "",
        element: <ProspectPage type={"CONTACT"} />,
      },
      {
        path: "prospects",
        element: <ProspectPage type={"PROSPECT"} />,
      },
      {
        path: "users",
        element: <ProspectPage type={"USER"} />,
      },
      {
        path: "users-actives",
        element: <ProspectPage type={"USER_ACTIVE"} />,
      },
      {
        path: "clients",
        element: <ProspectPage type={"CLIENT"} />,
      },
      {
        path: "clients-actifs",
        element: <ProspectPage type={"CLIENT_ACTIF"} />,
      },
      {
        path: "clients-engages",
        element: <ProspectPage type={"CLIENT_ENGAGE"} />,
      },
      {
        path: "clients-impactes",
        element: <ProspectPage type={"CLIENT_IMPACTE"} />,
      },
      {
        path: "messages",
        element: <ContactPage />,
      },
    ],
  },
  {
    path: ECOLES_PATH,
    element: <EcolePage />,
    subPath: [
      {
        path: "",
        element: <EcoleListePage />,
      },
      {
        path: "directeur",
        element: <EcoleDirecteurPage />,
      },
      {
        path: "maitre",
        element: <EcoleMaitrePage />,
      },
      {
        path: "parrains",
        element: <ParrainPage />,
      },
      {
        path: CLASSES_PATH,
        element: <ClassePage />,
      },
      {
        path: MATIERES_PATH,
        element: <MatierePage />,
      },
      {
        path: NIVEAUX_PATH,
        element: <NiveauxPage />,
      },
    ],
  },
  // {
  //   path: CLASSES_PATH,
  //   element: <ClassePage />,
  // },
  {
    path: FICHES_PATH,
    element: <Outlet />,
    subPath: [
      {
        element: <FichePage />,
        path: "",
      },
      {
        element: <FicheDetailsPage />,
        path: ":id",
      },
      {
        element: <ListeCoachsFiche />,
        path: "coach/:id",
      },
      {
        element: <FicheAjoutPage />,
        path: "ajout",
      },
    ],
  },
  // {
  //   path: MATIERES_PATH,
  //   element: <MatierePage />,
  // },
  // {
  //   path: NIVEAUX_PATH,
  //   element: <NiveauxPage />,
  // },
  {
    path: VILLES_PATH,
    element: <VillePage />,
  },
  {
    path: APPELS_PATH,
    element: <Outlet />,
    subPath: [
      {
        path: "",
        element: <AppelPage />,
      },
      {
        path: "create",
        element: <AppelCreatePage />,
      },
    ],
  },
  {
    path: PAIEMENTS_PATH,
    element: <PaiementPage />,
    subPath: [
      { path: "", element: <PaiementElevePage /> },
      { path: "parent", element: <PaiementParentPage /> },
    ],
  },
  {
    path: DIAGNOSTIQUES_PATH,
    element: <DiagnostiquePage />,
    handle: {
      // `crumb` is your own abstraction, we decided
      // to make this one a function so we can pass
      // the data from the loader to it so that our
      // breadcrumb is made up of dynamic content
      crumb: () => <span>Diagnostics</span>,
    },
    subPath: [
      {
        path: "",
        element: <Outlet />,
        subPath: [
          {
            path: "",
            element: <DiagnostiqueListe />,
            handle: {
              // `crumb` is your own abstraction, we decided
              // to make this one a function so we can pass
              // the data from the loader to it so that our
              // breadcrumb is made up of dynamic content
              crumb: () => <span>Diagnostics</span>,
            },
          },
          {
            path: ":id",
            element: <Outlet />,
            subPath: [
              {
                path: "",
                element: <DiagnostiqueListeDetails />,
                handle: {
                  // `crumb` is your own abstraction, we decided
                  // to make this one a function so we can pass
                  // the data from the loader to it so that our
                  // breadcrumb is made up of dynamic content
                  crumb: () => <span>Liste niveux</span>,
                },
              },
              {
                path: ":id",
                element: <Outlet />,
                subPath: [
                  {
                    path: "",
                    element: <EpreuveByNiveauPage />,
                    handle: {
                      // `crumb` is your own abstraction, we decided
                      // to make this one a function so we can pass
                      // the data from the loader to it so that our
                      // breadcrumb is made up of dynamic content
                      crumb: () => <span>Liste des exercices</span>,
                    },
                  },
                  {
                    path: ":id",
                    element: <EpreuveDetailPage />,
                    handle: {
                      // `crumb` is your own abstraction, we decided
                      // to make this one a function so we can pass
                      // the data from the loader to it so that our
                      // breadcrumb is made up of dynamic content
                      crumb: () => <span>Details epreuve</span>,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: DIAGNOSTIQUES_PARENT_FOR_STUDENTS_PATH,
            element: <DiagnosticParentEleve />,
            handle: {
              // `crumb` is your own abstraction, we decided
              // to make this one a function so we can pass
              // the data from the loader to it so that our
              // breadcrumb is made up of dynamic content
              crumb: () => <span>Diagnostics parent eleve</span>,
            },
          },
        ],
      },
      { path: "parent", element: <ParentDiagnosticPage /> },
      {
        path: "epreuves",
        element: <Outlet />,
        subPath: [
          {
            path: "",
            element: <EpreuvePage />,
          },
          {
            path: "coach",
            element: <EpreuveCoachPage />,
          },
          {
            path: "parent",
            element: <ParentDiagnosticPage />,
          },
          {
            path: "edit/:id",
            element: <ParentDiagnosticPage />,
          },
          {
            path: ":id",
            element: <EpreuveDetailPage />,
          },
        ],
      },
      {
        path: BULLETIN_PATH,
        element: <Outlet />,
        subPath: [
          {
            element: <BulletinPage />,
            path: "",
          },
          {
            path: ":id",
            element: <Outlet />,
            subPath: [
              {
                path: "",
                element: <BulletinListByClasse />,
              },
              {
                path: ":studentId",
                element: <Outlet />,
                subPath: [
                  {
                    path: "",
                    element: <BulletinEleve />,
                  },
                  { path: "eleve", element: <BulletinNote /> },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "feature-usage",
        element: <FeatureUsageStats />,
        handle: {
          crumb: () => <span>Usage fonctionnalités</span>,
        },
      },
      { path: "autres", element: "Autre Choses" },
    ],
  },
  {
    path: DIAGNOSTIQUES_PARENT_PATH,
    element: <DiagnostiqueParentListe />,
    subPath: [
      { path: "", element: <DiagnosticParentPage /> },
      {
        path: "quizz",
        element: <Outlet />,
        subPath: [
          { path: "", element: <DiagnostiqueQuizzList /> },
          { path: "add", element: <DiagnostiqueQuizzForm /> },
          { path: ":id", element: <DiagnostiqueQuizzDetails /> },
        ],
      },
      { path: "maths", element: <DiagnostiqueQuizzForm /> },
    ],
  },
  {
    element: <Outlet />,
    path: COMPOSITION_PATH,
    subPath: [
      {
        element: <CompositionPage />,
        path: "",
      },
      {
        element: <CompositionLIstePage />,
        path: ":id",
      },
    ],
  },

  // {
  //   path: PARTENAIRE_PATH,
  //   element: <Outlet />,
  //   subPath: [
  //     {
  //       path: "",
  //       element: <PartenaireHomePage />,
  //     },
  //     {
  //       path: "parent",
  //       element: <PartenaireParentPage />,
  //     },
  //   ],
  // },
];

/*
 ***************************************
 * PARTENAIRE ROUTES
 ***************************************
 */

export const privatePartenaireRoutes = [
  {
    path: "/partenaire",
    element: <Navigate to={PARTENAIRE_PATH} />,
  },
  {
    path: PARTENAIRE_PATH,
    element: <PartenaireHomePage />,
  },
  {
    path: "parents",
    element: <PartenaireParentPage />,
  },
];
